import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { ItineraryNavigatorComponent } from '../shared-components/itinerary-navigator/itinerary-navigator.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { ItineraryResultComponent } from './itinerary-result/itinerary-result.component';
import { HaveQuestionsComponent } from './have-questions/have-questions.component';
import { CancelPolicyComponent } from './cancel-policy/cancel-policy.component';
import { TravelBoardComponent } from './travel-board/travel-board.component';
import { TravelBoardQuickComponent } from './travel-board/travel-board-quick/travel-board-quick.component';
import { TravelBoardChooserComponent } from './travel-board/travel-board-chooser/travel-board-chooser.component';
import { TravelBoardEditComponent } from './travel-board/travel-board-edit/travel-board-edit.component';
import { TravelBoardResponseComponent } from './travel-board/travel-board-response/travel-board-response.component';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';


@NgModule({
	declarations: [
		BookingSummaryComponent,
		CancelPolicyComponent,
		FooterComponent,
		ItineraryNavigatorComponent,
		ItineraryResultComponent,
		HaveQuestionsComponent,
		TravelBoardComponent,
		TravelBoardQuickComponent,
		TravelBoardChooserComponent,
		TravelBoardEditComponent,
		TravelBoardResponseComponent,
		CookieBannerComponent
	],
	exports: [
		BookingSummaryComponent,
		CancelPolicyComponent,
		FooterComponent,
		ItineraryNavigatorComponent,
		ItineraryResultComponent,
		HaveQuestionsComponent,
		TravelBoardComponent,
		TravelBoardQuickComponent,
		TravelBoardChooserComponent,
		TravelBoardEditComponent,
		TravelBoardResponseComponent,
		CookieBannerComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		RouterModule
	]
})
export class SharedComponentsModule { }
